import React from 'react';
import UnderHeader from '../../../shared/header/under-header';
import NoInfoSoldContent from './components/do-not-sell-my-info-content';

import Head from '../../../shared/head';

const NoInfoSold = () => {
    const heroImageContent = (
    <div id="hero-footer" className="hero-footer">
        <div className="row">
        <h1 className="brandon-light">Do Not Sell My Information</h1>                        
        </div>
    </div>); 
    return(
        <>
            <Head title={`Loanpal ${window.location.pathname.split('/')[1]}`} />
            <UnderHeader                
                image="img-container-hero-footer-pages"                                
                bgColor="grey-header"
                border=""
                heroImageContent={heroImageContent}
                showDIYSlideshow={false}
                showSlideshowMovie={false}
            />
            <NoInfoSoldContent />                
        </>                
    )
}

export default NoInfoSold;